import React from "react";

const ContactGoogleForm = () => {
  return (
    <section className="container mt-5">
      <div className="row my-4">
        <iframe
          title="form"
          width="100%"
          height="1850px"
          src="https://forms.office.com/Pages/ResponsePage.aspx?id=KYJsGaVSEkCuAuXGKlet77L0HwHdeDRBsbUkr2ouo6RUN1ZIUFY3TFhaV0hYT1NQWEFaTE5TVkE5Wi4u"
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default ContactGoogleForm;
